import {EntityType, NewPermanentToken, PermanentToken, PermanentTokenForm} from "./Model";
import {arrayResource, EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {insertFirstElement} from "../util/ArrayUtil";
import {AxiosResponse} from "axios";
import api from "../util/api";
import {PermanentTokens_Read} from "../util/access/Permission";


interface PermanentTokenStore extends EntityStore<PermanentToken[]> {
    createPermanentToken: (form: PermanentTokenForm) => Promise<NewPermanentToken>,
    updatePermanentToken: (token: PermanentToken, form: PermanentTokenForm) => Promise<PermanentToken>,
    deletePermanentToken: (token: PermanentToken) => Promise<void>,
}

export const usePermanentTokenStore = create<PermanentTokenStore>()(
    arrayResource<PermanentToken, PermanentTokenStore>(EntityType.PermanentTokens, builder => {
        const rest = builder.crud<PermanentTokenForm>('/permanent-tokens', 'id');

        return {
            remoteValue: builder.all(PermanentTokens_Read, () => rest.getAll()),
            createPermanentToken: async (form: PermanentTokenForm) => {
                const response: AxiosResponse<NewPermanentToken> = await api.post('/permanent-tokens', form);
                const newPermanentToken = response.data;
                builder.patch(prevEntities => insertFirstElement(prevEntities, newPermanentToken.permanentToken));
                return newPermanentToken;
            },
            updatePermanentToken: builder.updateAndPatch<PermanentTokenForm>(rest),
            deletePermanentToken: builder.deleteAndPatch<PermanentTokenForm>(rest),
        };
    })
);

startEntityStore(usePermanentTokenStore);
